import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";

export default function ArreBoxSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [sub, setSub] = useState(null);
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let cancelled = false;
    const poll = async (n = 0) => {
      if (cancelled || n > 6) {
        setStatus(n > 6 ? "timeout" : status);
        return;
      }
      try {
        const { data } = await api.get(`/subscriptions/status/${sessionId}`);
        setSub(data.subscription);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        setAttempts(n + 1);
        setTimeout(() => poll(n + 1), 2500);
      } catch {
        setTimeout(() => poll(n + 1), 2500);
      }
    };
    poll(0);
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="bg-arre-black min-h-screen flex items-center justify-center px-6 py-20" data-testid="arrebox-success-page">
      <div className="max-w-xl w-full text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 text-arre-red animate-spin mx-auto mb-5" />
            <h1 className="font-display text-4xl tracking-wider uppercase text-white mb-2">Activando tu BOX...</h1>
            <p className="text-white/60">Procesando pago — intento {attempts + 1} de 6.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 bg-arre-red rounded-full flex items-center justify-center mx-auto mb-5">
              <Check className="w-8 h-8 text-white" strokeWidth={3} />
            </div>
            <div className="text-xs tracking-[0.35em] uppercase text-arre-red mb-3">⟡ Suscripción activa</div>
            <h1 className="font-display text-5xl tracking-wider uppercase text-white mb-3">¡Bienvenido al BOX, compare!</h1>
            {sub && (
              <div className="bg-arre-surface border border-arre-border p-6 my-6 text-left">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs tracking-widest uppercase text-white/50">Tier</span>
                  <span className="font-display text-xl text-white">{sub.tier_name}</span>
                </div>
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs tracking-widest uppercase text-white/50">Cargo mensual</span>
                  <span className="font-display text-xl text-arre-red">{fmtMXN(sub.price)}</span>
                </div>
                {sub.next_billing_date && (
                  <div className="flex items-center justify-between">
                    <span className="text-xs tracking-widest uppercase text-white/50">Próximo cargo</span>
                    <span className="text-white">{new Date(sub.next_billing_date).toLocaleDateString("es-MX")}</span>
                  </div>
                )}
              </div>
            )}
            <Link to="/cuenta" className="btn-arre bg-arre-red text-white font-display text-base tracking-widest uppercase px-6 py-3 inline-block" data-testid="go-account-btn">
              Ir a mi cuenta
            </Link>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <h1 className="font-display text-4xl tracking-wider uppercase text-white mb-3">Tomando más tiempo…</h1>
            <p className="text-white/60 mb-5">Si tu pago se completó, verás tu BOX en tu cuenta en breve.</p>
            <Link to="/cuenta" className="btn-arre bg-arre-red text-white font-display text-base tracking-widest uppercase px-6 py-3 inline-block">
              Ver mi cuenta
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
